const colors: Record<string, string> = {
  "xq-grey": "#F2F2F2",

  // Background Color
  "default-bg-color": "#FDFBF8",

  // Hover background:
  "tab-bg-hover": "#F6F6F6",
  // Pressed background:
  "tab-bg-press": "#E7E7E7",

  "tab-border": "#E7E4E0",

  // Fill and text color
  "dark-color": "#212121",
  "gray-text": "#4F4F4F",

  // GREYS
  "grey-50": "#888888",

  // BLUE GREEN
  "BG-10": "#F1FFF7",
  "BG-20": "#E4FFEF",
  "BG-30": "#D8FEE3",
  "BG-40": "#BDFCD7",
  "BG-50": "#83FBA3",
  "BG-55": "#1C7B7C",
  "BG-60": "#145758",
  "BG-70": "#134142",
  "BG-80": "#0C2D2E",

  // Learner Outcomes
  "FK-10": "#EFF8FF",
  "FK-20": "#E9F4FF",
  "FK-30": "#D1EAFF",
  "FK-40": "#97CBF1",
  "FK-50": "#469BD6",
  "FK-60": "#2C8ACC",
  "FK-70": "#1C6CAD",
  "FK-80": "#0C548F",
  "FK-90": "#07477C",
  "FK-100": "#08365F",

  "FL-10": "#FFF7E8",
  "FL-20": "#FFF4CB",
  "FL-30": "#FFE485",
  "FL-40": "#FFD646",
  "FL-50": "#FFBF1B",
  "FL-60": "#F7A600",
  "FL-70": "#E27A00",
  "FL-80": "#BB4F02",
  "FL-90": "#983C08",
  "FL-100": "#702100",

  "OT-10": "#FFF1F0",
  "OT-20": "#FFECE9",
  "OT-30": "#FFD4CE",
  "OT-40": "#FFB4AB",
  "OT-50": "#FD8677",
  "OT-60": "#EB5D4B",
  "OT-70": "#D73E2B",
  "OT-80": "#B53120",
  "OT-90": "#972010",
  "OT-100": "#801D0F",

  "GC-10": "#F8F6FF",
  "GC-20": "#F2EEFE",
  "GC-30": "#E5E0F7",
  "GC-40": "#DBCFF2",
  "GC-50": "#C4B2E3",
  "GC-60": "#AF97D0",
  "GC-70": "#9B80B9",
  "GC-80": "#815EA5",
  "GC-90": "#664489",
  "GC-100": "#533672",

  "LL-10": "#EEF9ED",
  "LL-20": "#E8F7E6",
  "LL-30": "#C7EEC4",
  "LL-40": "#9AE095",
  "LL-50": "#65C95F",
  "LL-60": "#3EA938",
  "LL-70": "#308F2A",
  "LL-80": "#277124",
  "LL-90": "#235A21",
  "LL-100": "#1E4A1D",
};

export default colors;
